// @flow

import * as React from 'react';
import {Helmet} from 'react-helmet-async';
import {useArticle} from 'docs/data';

export const OpenGraphMetaTags = () => {
  const {article} = useArticle();

  const articleTitle = article.metadata.title;
  const articleSubtitle = article.metadata.subtitle;
  const imageUrl = article.openGraphImageUrl;

  if (!imageUrl) {
    return null;
  }

  return (
    <Helmet>
      <meta property="og:type" content="website" />
      <meta property="og:title" content={articleTitle} />
      {articleSubtitle && (
        <meta property="og:description" content={articleSubtitle} />
      )}
      <meta property="og:image" content={imageUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={articleTitle} />
      {articleSubtitle && (
        <meta name="twitter:description" content={articleSubtitle} />
      )}
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};
